export class WorkspaceStorageAllowedCredentialsProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<WorkspaceStoragePermission>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceStorageAllowedCredentialsProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
